module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "liga-sekolah-menu"
    }
  }, [_c('h1', {
    staticClass: "page-header"
  }, [_vm._v("Pilih Menu Liga Sekolah")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4 col-sm-12"
  }, [_c('div', {
    staticClass: "widget widget-stats bg-purple"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "stats-link"
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/liga-sekolah/schedule'
      }
    }
  }, [_vm._v("Lihat Jadwal "), _c('i', {
    staticClass: "fa fa-arrow-circle-o-right"
  })])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-sm-12"
  }, [_c('div', {
    staticClass: "widget widget-stats bg-blue"
  }, [_vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "stats-link"
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/liga-sekolah/brackets'
      }
    }
  }, [_vm._v("Lihat Brackets "), _c('i', {
    staticClass: "fa fa-arrow-circle-o-right"
  })])], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stats-icon"
  }, [_c('img', {
    staticStyle: {
      "max-width": "80px"
    },
    attrs: {
      "src": "https://bonf-files.sgp1.digitaloceanspaces.com/assets/ic_tpa_verbal.png",
      "alt": "liga-schedule-logo"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stats-info"
  }, [_c('p', [_vm._v("Schedule")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stats-icon"
  }, [_c('img', {
    staticStyle: {
      "max-width": "80px"
    },
    attrs: {
      "src": "https://bonf-files.sgp1.digitaloceanspaces.com/assets/ic_physics.png",
      "alt": "liga-brackets-logo"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stats-info"
  }, [_c('p', [_vm._v("Brackets")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6fdd537b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/duel/liga_sekolah/LigaSekolahMenu.vue
// module id = 1363
// module chunks = 0